import React from 'react';
import { InvoiceTemplateProps } from './types';
import PatientInfo from './primitives/PatientInfo';
import ItemsTable from './primitives/ItemsTable';
import Totals from './primitives/Totals';

export default function Template4_SmallWithoutHeader({ invoice, hospital }: InvoiceTemplateProps) {
  return (
    <div className="bg-white p-4 max-w-[80mm] mx-auto text-xs">
      <div className="text-center mb-3">
        <h2 className="text-lg font-bold text-gray-900">CASH MEMO</h2>
        <p className="text-xs text-gray-600">{hospital.name}</p>
      </div>

      <PatientInfo invoice={invoice} layout="compact" />
      
      <ItemsTable items={invoice.items} variant="compact" headerColor="bg-blue-600" />
      
      <Totals invoice={invoice} layout="compact" showPaymentInfo={true} />
      
      <div className="text-center mt-3 text-xs text-gray-600">
        <p>Thank you!</p>
      </div>
    </div>
  );
}
